import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { App } from '@df/core/app';
import { Status } from '@df/core/status';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { BranchService } from '../../../branch/branch.service';
import { NModalLayout } from '../../modal/layout/modal-layout.component';
import { DeliveryPostcodeService } from '../delivery-postcode.service';
import { LocationPostcodeService } from '../location-postcode.service';

export namespace NCmsDelivery {
    export const MODAL_ID = 'product-delivery';
    export interface IModalData {
        productId?: number;
    }
}

@DfModal({
    id: NCmsDelivery.MODAL_ID,
    position: sizeName => (sizeName === 'X' || sizeName === 'L' ? 'right' : 'bottom'),
    config: size => ({
        ...(['S', 'M'].includes(size) ? NModalLayout.Bottom.modalConfig()(size) : NModalLayout.Right.modalConfig()(size)),
        modalClass: 'b-radius-4-top p-a-0'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: sizeId => ({ S: ['S'], M: ['M', 'L', 'X'], L: ['M', 'L', 'X'], X: ['M', 'L', 'X'] })[sizeId]
})
@Component({
    templateUrl: './delivery-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeliveryModalComponent {
    protected postcode?: string;
    protected status = new Status();
    protected locationStatus = new Status();
    protected location: { latitude: number; longitude: number } | null = null;

    constructor(
        private app: App,
        private modalRef: ModalRef<DeliveryModalComponent>,
        private changeDetectorRef: ChangeDetectorRef,
        @Inject(MODAL_DATA) readonly data: NCmsDelivery.IModalData,
        private deliveryPostcodeService: DeliveryPostcodeService,
        private locationPostcodeService: LocationPostcodeService,
        private branchService: BranchService
    ) {}

    ngOnInit(): void {
        if (this.app.isPlatformBrowser) {
            this.loadCurrentLocation();
        }
    }

    protected close() {
        this.modalRef.close();
    }

    protected async confirm() {
        if (!this.postcode) {
            return;
        }
        this.deliveryPostcodeService.updatePostcode(
            this.postcode,
            () => {
                this.modalRef.close();
                if (this.postcode && !this.branchService.branchNumber()) {
                    this.branchService.pickNearByBranch(this.postcode);
                }
            },
            undefined,
            this.status
        );
    }

    protected async loadCurrentLocation() {
        await this.locationPostcodeService.loadLocation(this.locationStatus, postcode => {
            this.postcode = postcode;
            this.detectChanges();
        });
    }

    protected detectChanges() {
        this.changeDetectorRef.detectChanges();
    }
}
